import { Link } from 'react-router-dom';
import { FaArrowRight, FaCalendar, FaUser } from 'react-icons/fa';
import './blog-section.css';

import { blogData } from '../../constants/blogData';

const BlogSection = ({ category = 'amaravati' }) => {
    const featuredPosts = blogData.filter(post => post.newsType === category && post.isFeatured);
    const sidebarPosts = blogData.filter(post => post.newsType === category && !post.isFeatured);

    const sectionTitle = category === 'hyderabad' ? 'Hyderabad News' : 'Amaravati News';
    const sidebarTitle = category === 'hyderabad' ? 'Hyderabad Real Estate' : 'Amaravati Real Estate';

    return (
        <section className="blog-section">
            <div className="container">
                <div className="blog-header-section">
                    <h2>{sectionTitle}</h2>
                </div>

                <div className="blog-layout">
                    {/* Featured Posts - Left Side */}
                    <div className="featured-posts">
                        {featuredPosts.map((post) => (
                            <div key={post.id} className="featured-post-card">
                                <div className="featured-post-image">
                                    <img src={post.image} alt={post.title} />
                                    <span className="post-category">{post.category}</span>
                                </div>
                                <div className="featured-post-content">
                                    <h3>{post.title}</h3>
                                    <div className="post-meta">
                                        <span><FaCalendar /> {post.date}</span>
                                        <span><FaUser /> {post.author}</span>
                                    </div>
                                    <p>{post.excerpt}</p>
                                    <Link to={`/blog/${post.slug}`} className="read-more-btn">
                                        READ MORE <FaArrowRight />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Sidebar Posts - Right Side */}
                    <div className="sidebar-posts">
                        <h3 className="sidebar-title">{sidebarTitle}</h3>
                        <div className="sidebar-posts-list">
                            {sidebarPosts.map((post) => (
                                <Link to={`/blog/${post.slug}`} key={post.id} className="sidebar-post-item">
                                    <img src={post.image} alt={post.title} />
                                    <div className="sidebar-post-info">
                                        <h4>{post.title}</h4>
                                        <span className="sidebar-post-date">{post.date}</span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlogSection;
